class AliquotaCodigoBarrasController extends AbstractController
  @$inject = ['$injector','$scope', 'pathService', 'aliquotaCodigoBarrasService']

  constructor: ($injector,  @scope, pathService, @aliquotaCodigoBarrasService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/aliquota-codigo-barras/"
    @modalAliquotaCodigoBarras = @openPopup(url + "modal.html", 'aliquotaCodigoBarrasModalController as ctrl')

    @listOfAliquotas = []

    @filtro =
      descricao: ''
      pendente: true

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @aliquotaCodigoBarrasService.getList(filtro, (result) =>
      if result.success
        @listOfAliquotas = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar a lista de alíquotas de código de barras.', 'Erro!', false)
    )

  detalhes: (aliquotaCodigoBarras) ->
    @modalAliquotaCodigoBarras({aliquotaCodigoBarras: -> aliquotaCodigoBarras}, (result) =>
      index = @listOfAliquotas.getIndex(aliquotaCodigoBarras.id, 'id')
      if result.ok
       if result.message == 'ncm_inconsistente' && index >= 0
          @listOfAliquotas.remove(index)
        else
          @listOfAliquotas[index] = result.data
      )

class AliquotaCodigoBarrasModalController extends AbstractController
  @$inject = ['$injector', 'gql', 'pathService', 'aliquotaCodigoBarrasService', '$uibModalInstance', 'aliquotaCodigoBarras']

  constructor: ($injector, @gql, pathService, @aliquotaCodigoBarrasService, @modalInstance, aliquotaCodigoBarras) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @aliquotaCodigoBarras = angular.copy aliquotaCodigoBarras

    aliquotas = [@aliquotaCodigoBarras.aliquotaInterna, @aliquotaCodigoBarras.aliquotaInterna.aliquotasEspeciais...]
      .map((item) =>
        [item, if item == @aliquotaCodigoBarras.aliquotaInterna then 'default' else item.id])

    [_item, @selecionada] = aliquotas.find(([item]) =>
      @aliquotaCodigoBarras.aliquotaConfirmada == item.aliquota and
        @aliquotaCodigoBarras.fonteLegal == item.fonteLegal and
        @aliquotaCodigoBarras.descricao == item.descricao and
        @aliquotaCodigoBarras.fonteLegalLink == item.fonteLegalLink) || []

    @aliquotaConfirmada = @aliquotaCodigoBarras.aliquotaConfirmada

    @aliquotas = aliquotas.reduce((acc, [item, id]) ->
      acc[id] = item

      acc
    , {})

  selecionar: (aliquota, id) ->
    @aliquotaCodigoBarras.aliquotaConfirmada = aliquota.aliquota
    @aliquotaCodigoBarras.fonteLegal = aliquota.fonteLegal
    @aliquotaCodigoBarras.descricao = aliquota.descricao
    @aliquotaCodigoBarras.fonteLegalLink = aliquota.fonteLegalLink

    @selecionada = id

  gerarDanfe: () ->
    cbk.download "/api/nfes/#{@aliquotaCodigoBarras.nfe.id}?format=pdf"

  confirmar: ($event) ->
    options =
      clickEvent: $event,
      loadingText: 'Confirmando...'

    @submitTracker.addPromise @aliquotaCodigoBarrasService.save(@aliquotaCodigoBarras, (data) =>
      @gql.mutate(gql(["mutation ($ncm: String!, $codigoBarras: String) {
        deleteAuditoriasContinuas(ncm: $ncm, codigoBarras: $codigoBarras)
      }"]), { ncm: @aliquotaCodigoBarras.ncm, codigoBarras: @aliquotaCodigoBarras.ean })

      Alert.success("A alíquota configurada para o código de barras Nº <strong>#{@aliquotaCodigoBarras.ean}</strong> referente
                     ao produto: <strong>#{@aliquotaCodigoBarras.descricao}</strong> foi <u>confirmada</u> com sucesso.", 'Sucesso!')

      @modalInstance.close(new Retorno(true, null, data))
    , options)

  delete: (status) ->
    Confirm.warning('Atenção', 'Deseja realmente excluir está confirmação de alíquota e relatar o NCM desde produto como inconsistente?', {
      'Sim': =>
        @aliquotaCodigoBarrasService.delete({id: @aliquotaCodigoBarras.id, status: status}, (data) =>
          if data
            Alert.success("O NCM inconsistente para a condição proposta Nº <strong>#{@aliquotaCodigoBarras.id}</strong> foi cadastrado com sucesso!", 'Sucesso!')
            @modalInstance.close(new Retorno(true, 'ncm_inconsistente', data))
        )
      'Não': => null
    })

  relatar: ->
    @delete('ncm_inconsistente')

angular.module('eficienciaFiscalModule').controller('aliquotaCodigoBarrasController', AliquotaCodigoBarrasController)
angular.module('eficienciaFiscalModule').controller('aliquotaCodigoBarrasModalController', AliquotaCodigoBarrasModalController)
